import api from "./axios";
import { WallpaperStatus, WallpaperUpdateRequest } from "../interfaces/Wallpaper";

export async function getWallpaperStatus(): Promise<WallpaperStatus> {
  const { data } = await api.get("/Wallpaper");
  return data;
}

export async function updateWallpaper(req: WallpaperUpdateRequest): Promise<WallpaperStatus> {
  const { data } = await api.put("/Wallpaper", req);
  return data;
}

/** Baixa a imagem atual (com auth) e devolve um object URL pra preview. */
export async function getWallpaperImageUrl(): Promise<string | null> {
  try {
    const res = await api.get("/Wallpaper/image", { responseType: "blob" });
    return URL.createObjectURL(res.data);
  } catch {
    return null;
  }
}
